import type { Editor } from "@tiptap/react";

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function serializeTextWithMarks(
  text: string,
  marks: ReadonlyArray<{ type: { name: string } }>,
): string {
  let out = escapeHtml(text);
  const names = new Set(marks.map((mark) => mark.type.name));
  if (names.has("italic")) {
    out = `<i>${out}</i>`;
  }
  if (names.has("bold")) {
    out = `<b>${out}</b>`;
  }
  return out;
}

/** Serialize TipTap doc to API body with `<signoff>`, `<mention>`, and inline format tags. */
export function serializeEditorBody(editor: Editor): string {
  let out = "";
  editor.state.doc.descendants((node) => {
    if (node.type.name === "signoffBadge" || node.type.name === "playbookBadge") {
      return;
    }
    if (node.type.name === "signoff") {
      const id = String(node.attrs.id ?? "").trim();
      const label = String(node.attrs.label ?? id).trim();
      const idAttr = id ? ` id="${id}"` : "";
      out += `<signoff${idAttr}>@${label}</signoff>`;
      return;
    }
    if (node.type.name === "playbook") {
      const label = String(node.attrs.label ?? node.attrs.id ?? "").trim();
      out += `<playbook>@${label}</playbook>`;
      return;
    }
    if (node.type.name === "mention") {
      const id = String(node.attrs.id ?? "").trim();
      const label = String(node.attrs.label ?? id).trim();
      const idAttr = id ? ` id="${id}"` : "";
      out += `<mention${idAttr}>@${label}</mention>`;
      return;
    }
    if (node.type.name === "hardBreak") {
      out += "\n";
      return;
    }
    if (node.isText) {
      out += serializeTextWithMarks(node.text ?? "", node.marks);
    }
  });
  return out;
}
